enum MeasureColors {
    Wall = "#f27212",
    Window = "#0aa3e8",
    Door = "#1dd70f",
    Room = "#cc99ff"
}

export default MeasureColors;